import { configuratorBridge } from '../../../Configurator/unity/unityMethods';

export class UndoRedoConfiguratorCameraValues {
  constructor({ undoRedoInstance, unityContext }) {
    this.undoRedo = undoRedoInstance;
    this.unityContext = unityContext;
    this.init();
  }

  init = () => {
    this.changeConfiguratorCameraValues = this.undoRedo.createAction(
      ({ currentValue, prevValue, setCameraFields }) => {
        const historyValue = {
          data: {
            currentValue,
            prevValue,
          },
          undo: () => {
            configuratorBridge.UpdateCameraProperties(prevValue.unityData);
            setCameraFields(prevValue.reduxData);
          },
          redo: () => {
            configuratorBridge.UpdateCameraProperties(currentValue.unityData);
            setCameraFields(currentValue.reduxData);
          },
        };
        return historyValue;
      }
    );
  };
}
